import {Mapper} from '@s-ui/domain'

export class AdComplaintConfigFormValueObjectMapper extends Mapper {
  constructor({config, configFormVOFactory, getConfigFieldsFormMapper}) {
    super()
    this._config = config
    this._configFormVOFactory = configFormVOFactory
    this._REGEX_EMAIL = config.get('REGEX_EMAIL')
    this._defaultInitFieldValue = this._config.get('form').defaultInitFieldValue
    this._displayTypes = this._config.get('form').displayTypes
    this._formIds = this._config.get('form').formIds
    this._formTypes = this._config.get('form').formTypes
    this._formFieldIds = this._config.get('form').formFieldIds
    this._getConfigFieldsFormMapper = getConfigFieldsFormMapper
  }

  setParams({complaintTypeId, userEntity}) {
    this._user = userEntity ? userEntity.toJSON() : null

    const {
      COMPLAINT_TYPES_WITH_NO_COMMENTS_FIELD,
      COMPLAINT_TYPES_WITH_OPTIONAL_COMMENTS_FIELD,
      COMPLAINT_TYPES_WITH_OPTIONAL_USER_DATA,
      COMPLAINT_TYPES_WITH_REQUIRED_USER_DATA
    } = this._config.get('report')

    this._isCommentsField = !COMPLAINT_TYPES_WITH_NO_COMMENTS_FIELD.includes(complaintTypeId)
    this._isCommentsFieldOptional = COMPLAINT_TYPES_WITH_OPTIONAL_COMMENTS_FIELD.includes(complaintTypeId)
    this._withOptionalUserData = COMPLAINT_TYPES_WITH_OPTIONAL_USER_DATA.includes(complaintTypeId)
    this._withRequiredUserData = COMPLAINT_TYPES_WITH_REQUIRED_USER_DATA.includes(complaintTypeId)
    return this
  }

  _getCommentsFieldCustomConfig() {
    return {
      customConstraints: {
        maxLength: {value: '3000'},
        notNull: {
          message: 'AD_COMPLAINT.COMPLAINT_COMMENT_REQUIRED_ERROR_TEXT'
        }
      },
      customProps: {
        hint: 'AD_COMPLAINT.COMPLAINT_COMMENT_HINT'
      }
    }
  }

  _getCommentsOptionalFieldCustomConfig() {
    return {
      customConstraints: {
        maxLength: {value: '3000'}
      },
      customProps: {
        hint: 'AD_COMPLAINT.COMPLAINT_COMMENT_HINT',
        label: 'FORM.COMMENTS_OPTIONAL_LABEL',
        required: false
      }
    }
  }

  _getEmailOptionalFieldCustomConfig() {
    return {
      customConstraints: {
        maxLength: {value: '80'},
        pattern: {
          message: 'FORM.EMAIL_TEXT_ERROR',
          pattern: this._REGEX_EMAIL.source
        }
      },
      customProps: {
        label: 'FORM.EMAIL_OPTIONAL_LABEL',
        required: false
      }
    }
  }

  _getNameOptionalFieldCustomConfig() {
    return {
      customConstraints: {
        maxLength: {value: '30'}
      },
      customProps: {
        label: 'FORM.CONTACT_NAME_OPTIONAL_LABEL',
        required: false
      }
    }
  }

  map() {
    const {comments, dataPrivacyCheckbox, email, name, reliableInfoCheckbox} = this._formFieldIds

    const isWithUserData = this._withOptionalUserData || this._withRequiredUserData
    const isDataPrivacyCheckbox = !this._user && isWithUserData

    const fields = []
    const initialFieldValues = {
      [comments]: this._defaultInitFieldValue
    }

    if (isWithUserData) {
      fields.push(
        ...[
          {
            field: name,
            ...(this._withOptionalUserData && this._getNameOptionalFieldCustomConfig())
          },
          {
            field: email,
            ...(this._withOptionalUserData && this._getEmailOptionalFieldCustomConfig())
          }
        ]
      )
      initialFieldValues[email] = (this._withRequiredUserData && this._user?.[email]) || this._defaultInitFieldValue
      initialFieldValues[name] = (this._withRequiredUserData && this._user?.[name]) || this._defaultInitFieldValue
    }

    this._isCommentsField &&
      fields.push({
        field: comments,
        ...(this._isCommentsFieldOptional
          ? this._getCommentsOptionalFieldCustomConfig()
          : this._getCommentsFieldCustomConfig())
      })

    if (isDataPrivacyCheckbox) {
      fields.push({field: dataPrivacyCheckbox})
      initialFieldValues[dataPrivacyCheckbox] = this._defaultInitFieldValue
    }

    if (isWithUserData) {
      fields.push({field: reliableInfoCheckbox})
      initialFieldValues[reliableInfoCheckbox] = this._defaultInitFieldValue
    }

    return this._configFormVOFactory({
      form: {
        display: this._displayTypes.block,
        fields: this._getConfigFieldsFormMapper.map(fields),
        id: this._formIds.adComplaint,
        type: this._formTypes.fieldset
      },
      initialFieldValues
    })
  }
}
